const rentalDealsConfig = [
  {
    field: "id",
    label: "Идентификатор",
    sortable: true,
  },
  {
    field: "deal_number",
    label: "Номер сделки",
    sortable: true,
  },
  {
    field: "start_date",
    label: "Дата начала",
    sortable: true,
  },
  {
    field: "end_date",
    label: "Дата окончания",
    sortable: true,
  },
  {
    field: "client.display_name",
    label: "Клиент",
    sortable: true,
  },
  {
    field: "asset.name",
    label: "Актив",
    sortable: true,
  },
  {
    field: "amount",
    label: "Сумма",
    sortable: true,
  },
  {
    field: "amount_due",
    label: "К доплате",
    sortable: true,
  },
  {
    field: "total_paid",
    label: "Оплачено",
    sortable: true,
  },
  {
    field: "status",
    label: "Статус",
    sortable: true,
  },
  {
    field: "created_at",
    label: "Дата создания",
    sortable: true,
  },
  {
    field: "updated_at",
    label: "Дата обновления",
    sortable: true,
  },
];

export default rentalDealsConfig;
